<template>
  <div class="overlay">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // slug: this.$route.params.slug,
    };
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  z-index: 1000;
  width: 100%;
  max-width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: flex-end;
  background-color: transparent;
  pointer-events: none;
  border-top: 1px solid var(--lightGray);
  //tablet
  @media (min-width: 768px) {
    width: 450px;
    max-width: calc(100% - 90px);
  }
  //desktop
  // @media (min-width: 1024px) {
  //   width: 800px;
  //   max-width: calc(100% - 90px);
  // }
}
</style>
